import { render } from "./ProductCostReceivingAddModal.vue?vue&type=template&id=1c0ddbc6"
import script from "./ProductCostReceivingAddModal.vue?vue&type=script&lang=js"
export * from "./ProductCostReceivingAddModal.vue?vue&type=script&lang=js"

import "./ProductCostReceivingAddModal.vue?vue&type=style&index=0&id=1c0ddbc6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__